<template>
	<div id="nodeSelectionList" ref="nodeSelectionList" :class="'nodeSelectionModal ' + (visible ? 'show' : 'hide')">
		<el-tabs id="wf-tour-node-tabs" style="margin-top: 10px" v-model="activeFilterGroup" tab-position="top">
			<el-tab-pane :disabled="filter.disabled" :key="filter.name" v-for="filter in filterGroups"
				:name="filter.name" :label="filter.name">
			</el-tab-pane>
		</el-tabs>
		<el-input id="wf-tour-node-search" v-if="!isTemplatesTab" clearable placeholder="Search by integration name" prefix-icon="el-icon-search"
			v-model="searchQuery" style="width: 100%; margin-top: 20px; margin-bottom: 10px">
		</el-input>
		<el-tabs v-if="!isTemplatesTab" v-model="activeFilter" tab-position="top">
			<el-tab-pane :key="filter.name" v-for="filter in filters" :name="filter.name" :label="filter.name">
			</el-tab-pane>
		</el-tabs>
		<div class="template-section" v-if="isTemplatesTab">
			<div class="section">

				<div class="section-title">
					Search Templates
				</div>

				<el-input type="textarea" :rows="4" v-model="templateSearchText"
					placeholder="Describe what you want to build..." style="margin: 16px 0" />

				<el-button type="primary" style="width: 100%" :loading="templateIsLoading"
					:disabled="!templateSearchText.trim()" @click="searchTemplates(1)">
					Search Templates
				</el-button>

				<div class="section-help">
					Describe your use case to find matching workflow templates. Insert them directly into your
					workflow.
				</div>
			</div>

			<div class="sticky-suggestions" v-if="templateMatches.length">
				<div class="suggestion-title">
					Suggested Templates
				</div>

				<div v-for="template in templateMatches" :key="template.templateId" class="suggestion-card">
					<div class="suggestion-left">
						<img class="suggestion-logo" :src="`data:image/${template.workflowNodes[0].iconMimeType === 'png' ? 'png' : 'svg+xml'};base64, ` +
							template.workflowNodes[0].icon" />
					</div>

					<div class="suggestion-right">
						<div class="suggestion-name">
							{{ template.name }}
						</div>

						<div class="suggestion-flow">
							{{ template.description }}
						</div>

						<div class="suggestion-footer">
							<div class="suggestion-score">
								Match: {{ template.matchScore }}%
							</div>

							<el-button size="mini" type="primary" @click="insertTemplate(template)">
								Insert
							</el-button>
						</div>
					</div>
				</div>
			</div>
			<el-empty style="padding: 0;" v-if="!hasSearchedTemplates && templateSearchText && !templateMatches.length"
				:image="require('../assets/empty.svg')"
				description="Describe your use case and click Search Templates" />

			<el-empty style="padding: 0;" v-if="hasSearchedTemplates && !templateIsLoading && !templateMatches.length && !isAiEnabled"
				:image="require('../assets/empty.svg')" description="No templates found" />
			<div v-if="hasSearchedTemplates && !templateIsLoading && !templateMatches.length && isAiEnabled"
				class="ai-agentic-cta">
				<div v-for="(msg) in agenticChat" :key="msg.id" class="ai-chat-box">
					<div class="ai-chat-text markdown" v-html="renderMarkdown(msg.text)"></div>

					<div class="ai-chat-actions" v-if="msg.buttonsEnabled && msg.text && !agenticLoading">
						<el-button size="mini" type="primary" :disabled="agenticLoading" @click="confirmAgentic(msg)">
							Yes, generate workflow
						</el-button>

						<el-button size="mini" :disabled="agenticLoading" @click="startRefine(msg)">
							No, I want to change something
						</el-button>
					</div>
				</div>

				<div v-if="agenticLoading" class="ai-thinking">
					<span>Thinking</span>
					<span class="dots">
						<i></i><i></i><i></i>
					</span>
				</div>

				<div v-if="!agenticActive && !agenticLoading" class="ai-cta-box">
					<div class="ai-cta-title">Let AI build this workflow for you</div>
					<div class="ai-cta-desc">
						Explain your requirements, and the AI will automatically generate the workflow.
					</div>

					<el-button type="primary" style="width:100%;margin-top:12px" @click="createAgenticTool">
						Create Agentic Workflow
					</el-button>
				</div>

				<div v-if="agenticRefineMode && !agenticLoading" class="ai-sticky-input">
					<el-input type="textarea" :rows="2" v-model="agenticInput"
						placeholder="Tell AI what you want to change..." />
					<el-button type="primary" size="mini" style="margin-top:6px"
						:disabled="agenticLoading || !agenticInput.trim()" @click="submitRefine">
						Submit
					</el-button>
				</div>
			</div>
			<el-pagination v-if="templateTotal > templatePageSize" :small="true" :pager-count="5"
				layout="prev, pager, next" background :total="templateTotal" :current-page.sync="templatePage"
				:page-size="templatePageSize" @current-change="searchTemplates($event)" />
		</div>
		<el-empty :image="require('../assets/empty.svg')" v-if="!filteredProxyList.length && !isTemplatesTab"
			description="No Integrations"></el-empty>
		<div :key="activeFilterGroup + activeFilter + searchQuery" v-if="filteredProxyList.length && !isTemplatesTab">
			<LazyList defaultLoadingColor="#210f3c" :data="filteredProxyList" :itemsPerRender="15"
				containerClasses="list">
				<template v-slot="{ item }">
					<div @click="insertNode(item)" :id="item.nodesObjectPropertyName" @dragstart="dragstart"
						@dragend="dragend" draggable="true"
						:class="'item ' + (contextualAssociations ? 'clickable' : '')">
						<div class="innerItemWrapper">
							<img v-if="item.icon" class="nodeIcon" :src="`data:image/${item.iconMimeType === 'png' ? 'png' : 'svg+xml'};base64, ` + item.icon
								" />
							<img v-if="!item.icon" class="nodeIcon" src="../assets/node.svg" />
							<div style="margin-left: 10px">
								<h4>{{ item.displayName }}</h4>
							</div>
							<div style="margin-left: auto">
								<i style="font-size: 20px"
									:class="contextualAssociations ? 'el-icon-thumb' : 'el-icon-rank'"></i>
							</div>
						</div>
					</div>
				</template>
			</LazyList>
		</div>
	</div>
</template>

<script>
import LazyList from "lazy-load-list/vue";
import { mapActions, mapGetters } from "vuex";
import MarkdownIt from "markdown-it";
let ghostEle;
export default {
	components: { LazyList },
	props: {
		visible: Boolean,
		nodeSelectionFilter: Object,
	},
	computed: {
		...mapGetters([
			"getStickyNoteMatches",
			"isStickyNotesLoading",
			"getStickyNoteTotal",
			"getSelectedWorkflowVersion"
		]),
		filteredProxyList() {
			if (this.activeFilterGroup === "Templates") {
				return [];
			}
			let filtered = [];
			if (this.activeFilterGroup === "Actions") {
				filtered = this.list.filter((each) => {
					return !each.integration.toLowerCase().includes("trigger") && !each.toolAssociation;
				});
			} else if (this.activeFilterGroup === "Triggers") {
				filtered = this.list.filter((each) => {
					return each.integration.toLowerCase().includes("trigger") && !each.toolAssociation;
				});
			} else {
				filtered = this.list.filter((each) => {
					return each.toolAssociation;
				});
			}
			//Sub filters
			if (this.activeFilter === "Marketing") {
				filtered = filtered.filter((each) => {
					return each.categories.includes("Marketing");
				});
			}
			if (this.activeFilter === "Ecommerce") {
				filtered = filtered.filter((each) => {
					return each.categories.includes("Ecommerce");
				});
			}
			if (this.activeFilter === "Messaging") {
				filtered = filtered.filter((each) => {
					return each.categories.includes("Messaging");
				});
			}
			if (this.activeFilter === "Sales & CRM") {
				filtered = filtered.filter((each) => {
					return each.categories.includes("Sales & CRM");
				});
			}
			if (this.activeFilter === "Data & Storage") {
				filtered = filtered.filter((each) => {
					return each.categories.includes("Data & Storage");
				});
			}
			if (this.activeFilter === "Development & Cloud") {
				filtered = filtered.filter((each) => {
					return each.categories.includes("Development & Cloud");
				});
			}
			if (this.activeFilter === "System Specific") {
				filtered = filtered.filter((each) => {
					return each.categories.includes("System Specific");
				});
			}
			if (this.activeFilter === "Finance & Accounting") {
				filtered = filtered.filter((each) => {
					return each.categories.includes("Finance & Accounting");
				});
			}
			if (this.activeFilter === "Analytics") {
				filtered = filtered.filter((each) => {
					return each.categories.includes("Analytics");
				});
			}
			if (this.activeFilter === "Social") {
				filtered = filtered.filter((each) => {
					return each.categories.includes("Social");
				});
			}
			if (this.activeFilter === "IOT") {
				filtered = filtered.filter((each) => {
					return each.categories.includes("IOT");
				});
			}
			if (this.activeFilter === "AI") {
				filtered = filtered.filter((each) => {
					return each.categories.includes("AI");
				});
			}
			if (this.nodeSelectionFilter?.type) {
				filtered = filtered.filter((each) => {
					return each.defaultOutputs.includes(this.nodeSelectionFilter.type);
				});
				if (this.nodeSelectionFilter?.filter?.nodes?.length) {
					filtered = filtered.filter((each) => {
						return this.nodeSelectionFilter?.filter?.nodes.includes(each.integration);
					});
				}
			}
			if (this.searchQuery) {
				return filtered.filter((integration) => {
					return integration.displayName.toLowerCase().includes(this.searchQuery.toLowerCase());
				});
			}
			return [...filtered].sort((a, b) => a.displayName.localeCompare(b.displayName));
		},
		isTemplatesTab() {
			return this.activeFilterGroup === "Templates";
		},
		templateIsLoading() {
			return this.isStickyNotesLoading;
		}
	},
	watch: {
		templateSearchText() {
			this.hasSearchedTemplates = false;
		},
		nodeSelectionFilter: {
			handler() {
				this.activeFilter = "All";
				this.activeFilterGroup = "Associations";
				if (this.nodeSelectionFilter) {
					this.disableEnableGroups(true);
				}
			},
			deep: true,
		},
		activeFilterGroup(val) {
			if (val === "Templates") {
				this.templateSearchText = "";
				this.templateMatches = [];
				this.templatePage = 1;
			}
			if (val === "Templates") {
				this.activeFilter = "All";
			}
		}
	},
	data() {
		return {
			searchQuery: "",
			activeFilterGroup: "Actions",
			activeFilter: "All",
			filterGroups: [
				{ name: "Triggers", disabled: false },
				{ name: "Actions", disabled: false },
				{ name: "Associations", disabled: false },
				{ name: "Templates", disabled: false },
			],
			filters: [
				{ name: "All" },
				{ name: "AI" },
				{ name: "System Specific" },
				{ name: "Marketing" },
				{ name: "Ecommerce" },
				{ name: "Messaging" },
				{ name: "Sales & CRM" },
				{ name: "Data & Storage" },
				{ name: "Development & Cloud" },
				{ name: "Finance & Accounting" },
				{ name: "Analytics" },
				{ name: "Social" },
				{ name: "IOT" },
			],
			list: [],
			dragNodeName: "",
			contextualAssociations: false,
			templateSearchText: "",
			templateMatches: [],
			templateLoading: false,
			templatePage: 1,
			templatePageSize: 5,
			templateTotal: 0,
			hasSearchedTemplates: false,
			aiMode: false,
			aiThinking: false,
			aiMessages: [],
			awaitingConfirmation: false,
			agenticChat: [],
			agenticLoading: false,
			agenticInput: "",
			agenticActive: false,
			isAiEnabled: false,
			agenticRefineMode: false
		};
	},
	mounted() {
		this.returnAllNodes();
		document.addEventListener("mousedown", this.emitClose, true);
		document.addEventListener("keyup", this.keyPress, true);
	},
	beforeDestroy() {
		document.removeEventListener("mousedown", this.emitClose, true);
		document.removeEventListener("keyup", this.keyPress, true);
	},
	methods: {
		...mapActions([
			"fetchStickyNoteTemplatesMETHOD",
			"insertTemplateIntoWorkflowMETHOD",
			"returnSpecificWorkflowMETHOD"
		]),
		renderMarkdown(text) {
			const md = new MarkdownIt({
				html: false,
				linkify: true,
				breaks: true
			});

			return md.render(text || "");
		},
		async createAgenticTool() {
			this.agenticActive = true;
			this.agenticLoading = true;

			try {
				const res = await this.httpHelper(
					"RUNTIME",
					"POST",
					"ai/generatePrompt",
					{ description: this.templateSearchText }
				);

				if (res?.response?.data?.error) {
					throw new Error(res?.response?.data?.error);
				}

				if (!res || !res.response?.proposedPrompt) {
					throw new Error("No AI response");
				}

				this.agenticChat.forEach(m => m.buttonsEnabled = false);

				this.agenticChat.push({
					id: Date.now(),
					role: "ai",
					text: res.response?.proposedPrompt,
					buttonsEnabled: true,
					workflowPlan: res.response.workflowPlan,
					descriptionText: res.response.descriptionText,
					industry: res.response.industry,
					tags: res.response.tags,
					department: res.response.department,
				});

			} catch (e) {
				this.$notify({
					title: "Error",
					message: e || "AI failed to generate workflow",
					type: "error",
					position: "bottom-left"
				});
			} finally {
				this.agenticLoading = false;
			}
		},

		startRefine() {
			this.agenticChat.forEach(m => m.buttonsEnabled = false);
			this.agenticRefineMode = true;
			this.agenticInput = "";
		},

		async submitRefine() {
			this.agenticRefineMode = false;
			this.agenticLoading = true;

			const lastPrompt = this.agenticChat[this.agenticChat.length - 1].text;

			const res = await this.httpHelper(
				"RUNTIME",
				"POST",
				"ai/generatePrompt",
				{
					previousPrompt: lastPrompt,
					userFeedback: this.agenticInput
				}
			);

			if (res?.response?.data?.error) {
				this.$notifyError(this, res?.response?.data?.error);
			}

			this.agenticChat.forEach(m => m.buttonsEnabled = false);

			this.agenticChat.push({
				id: Date.now(),
				role: "ai",
				text: res.response.proposedPrompt,
				buttonsEnabled: true,
				workflowPlan: res.response.workflowPlan,
				descriptionText: res.response.descriptionText,
				industry: res.response.industry,
				tags: res.response.tags,
				department: res.response.department,
			});

			this.agenticInput = "";
			this.agenticLoading = false;
			this.agenticRefineMode = false;
		},

		async confirmAgentic(msg) {
			msg.buttonsEnabled = false;
			this.agenticRefineMode = false;
			this.agenticLoading = true;
			const zoom = this.$store.state.canvasZoom;

			try {
				const res = await this.httpHelper(
					"RUNTIME",
					"POST",
					"ai/generateWorkflow",
					{
						workflowPlan: msg.workflowPlan,
						descriptionText: msg.descriptionText,
						zoom,
						industry: msg.industry,
						tags: msg.tags,
						department: msg.department,
					}
				);

				if (res?.response?.data?.error) {
					throw new Error(res?.response?.data?.error);
				}

				if (res?.error) {
					throw new Error(res?.error?.message || "Failed to generate workflow");
				}

				this.templateSearchText = msg.descriptionText || "";
				this.activeFilterGroup = "Templates";
				await this.searchTemplates(1);

			} catch (e) {
				this.$notify({
					title: "Error",
					message: e || "AI failed to generate workflow",
					type: "error",
					position: "bottom-left"
				});
			} finally {
				this.agenticLoading = false;
			}
		},
		async searchTemplates(page = 1) {
			this.hasSearchedTemplates = true;

			this.agenticActive = false;
			this.agenticLoading = false;
			this.agenticRefineMode = false;
			this.agenticChat = [];
			this.agenticInput = "";

			this.templatePage = page;
			this.templateLoading = true;

			try {
				const res = await this.httpHelper(
					"RUNTIME",
					"GET",
					"ai/checkAiEligibility"
				);

				if (res?.response?.data?.error) {
					throw new Error(res?.response?.data?.error);
				}

				const isAiEnabled = res.response.aiEnabled;
				this.isAiEnabled = isAiEnabled;
			} catch (e) {
				this.$notify({
					title: "Error",
					message: e || "failed to search templates",
					type: "error",
					position: "bottom-left"
				});
			}

			const result = await this.$store.dispatch(
				"fetchStickyNoteTemplatesMETHOD",
				{
					description: this.templateSearchText,
					page: this.templatePage,
					limit: this.templatePageSize
				}
			);

			if (!result?.error) {
				this.templateMatches = this.getStickyNoteMatches || [];
				this.templateTotal = this.getStickyNoteTotal || 0;
			}

			this.templateLoading = this.isStickyNotesLoading;
		},

		async insertTemplate(template) {
			try {
				const storedVersion = this.$store.getters.getSelectedWorkflowVersion(
					this.$route.params.workflowId
				);

				const result = await this.$store.dispatch(
					"returnSpecificWorkflowMETHOD",
					{
						workflowId: this.$route.params.workflowId,
						versionId: storedVersion,
					}
				);

				const data = {
					template: {
						workflowNodes: template?.workflowNodes
					},
					workflowId: this.$route.params.workflowId,
					versionId: storedVersion,
					workflowLastUpdated: result?.updatedAt,
				};

				const response = await this.$store.dispatch(
					"insertTemplateIntoWorkflowMETHOD",
					data
				);

				this.$emit("refresh-workflow");
				this.$emit("close");

				if (!response?.error) {
					this.$notify({
						title: "Success",
						message: "Template added to workflow",
						type: "success",
						position: "bottom-left"
					});
				} else {
					throw response;
				}
			} catch (e) {
				this.$notify({
					title: "Error",
					message: e?.error?.message || "Failed to insert template",
					type: "error",
					position: "bottom-left"
				});
			}
		},
		insertNode(node) {
			if (this.contextualAssociations) {
				this.$emit("insertContextualNode", { ...node, contextualInputNodeId: this.nodeSelectionFilter.id });
				this.$emit("close");
			}
		},
		disableEnableGroups(disable) {
			this.filterGroups = this.filterGroups.map((each) => {
				if (each.name !== "Associations") {
					this.contextualAssociations = disable ? true : false;
					each.disabled = disable;
				}
				return each;
			});
		},
		keyPress(e) {
			if (e.key === "Escape") {
				this.$emit("close");
				this.disableEnableGroups(false);
			}
		},
		emitClose(e) {
			if (
				e.target.id !== "nodeSelectionList" &&
				!this.$refs.nodeSelectionList.contains(e.target) &&
				e.target.parentNode.id !== "newNodeBtn" &&
				!(e.target.closest && e.target.closest(".tour-card"))
			) {
				this.$emit("close");
				this.disableEnableGroups(false);
			}
		},
		dragend(e) {
			if (e.dataTransfer.dropEffect === "copy" || e.dataTransfer.dropEffect === "move") {
				this.$emit("nodeDropped", { name: this.dragNodeName, event: e });
			}
			document.body.removeChild(ghostEle);
		},
		dragstart(e) {
			this.$emit("nodeDraggingStarted");
			this.dragNodeName = e.target.id.trim();
			ghostEle = e.target.cloneNode(true);
			ghostEle.style.width = "70px";
			ghostEle.style.height = "70px";
			ghostEle.style.borderRadius = "15px";
			ghostEle.style.border = "1.5px solid #A2A2B5";
			if (ghostEle.childNodes[0].childNodes[0].style) {
				ghostEle.childNodes[0].childNodes[0].style.width = "70px";
			} else {
				ghostEle.childNodes[0].childNodes[1].style.width = "70px";
			}
			ghostEle.childNodes[0].removeChild(ghostEle.childNodes[0].childNodes[3]);
			ghostEle.childNodes[0].removeChild(ghostEle.childNodes[0].childNodes[2]);
			ghostEle.style.padding = "12px";
			ghostEle.style.backgroundColor = "white";
			document.body.appendChild(ghostEle);
			e.dataTransfer.setDragImage(ghostEle, 0, 0);
		},
		async returnAllNodes() {
			const result = await this.httpHelper("RUNTIME", "GET", "nodes/returnAllNodeDefinitions", {});
			if (!result?.error) {
				this.list = Object.freeze(result.response);
			}
		},
	},
};
</script>

<style scoped>
.nodeSelectionModal {
	width: 399px;
	border-right: 1px solid #e9e9eb;
	height: calc(100vh - 140px);
	position: relative;
	background-color: white;
	position: absolute;
	left: 0;
	bottom: 0px;
	z-index: 1000;
	transition: 0.3s ease all;
	padding-left: 20px;
	padding-right: 20px;
	overflow: hidden;
	cursor: default;
}

.show {
	left: 0;
	opacity: 0.95;
}

.hide {
	opacity: 0;
	left: -440px;
}

.nodeSelectionModal /deep/ .el-tabs__header {
	margin-bottom: 0px !important;
}

.list {
	padding-top: 20px !important;
	max-height: calc(100vh - 319px);
}

.nodeSelectionModal /deep/ .item {
	box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
	border-radius: 4px;
	padding: 10px;
	width: calc(95% - 20px);
	margin-left: 2px;
	cursor: grab;
	margin-bottom: 5px;
	background-color: white;
	position: relative;
	display: flex;
}

.nodeSelectionModal /deep/ .clickable {
	cursor: pointer !important;
}

.nodeSelectionModal /deep/ .innerItemWrapper {
	display: inline-flex;
	align-items: center;
	flex: 1;
}

.nodeIcon {
	width: 40px;
}

h4 {
	margin: 0px;
}

.el-textarea__inner {
	text-align: left;
}

.section {
	margin-block: 20px;
}

.section-title {
	font-size: 14px;
	font-weight: 600;
	color: #111827;
	text-align: left;
}

.section-help {
	font-size: 12px;
	color: #6b7280;
	margin-top: 6px;
	text-align: left;
}

.el-textarea__inner {
	text-align: left;
}

.suggestion-name,
.suggestion-flow,
.suggestion-score {
	text-align: left;
}

.divider {
	display: flex;
	align-items: center;
	gap: 10px;
	margin: 16px 0;
	font-size: 12px;
	color: #9ca3af;
}

.divider::before,
.divider::after {
	content: "";
	flex: 1;
	height: 1px;
	background-color: #e5e7eb;
}

.sticky-primary-btn {
	background: #111827;
	border-color: #111827;
}

.sticky-primary-btn:hover {
	background: #000000;
	border-color: #000000;
}

.sticky-suggestions {
	margin-top: 24px;
}

.suggestion-title {
	font-size: 13px;
	font-weight: 600;
	margin-bottom: 12px;
	color: #111827;
}

.suggestion-card {
	display: flex;
	border: 1px solid #e5e7eb;
	border-radius: 8px;
	padding: 12px;
	margin-bottom: 12px;
}

.suggestion-left {
	margin-right: 12px;
}

.suggestion-logo {
	width: 36px;
	height: 36px;
	object-fit: contain;
}

.suggestion-right {
	flex: 1;
}

.suggestion-name {
	font-weight: 600;
	color: #111827;
}

.suggestion-flow {
	font-size: 12px;
	color: #6b7280;
	margin-top: 6px;
}

.suggestion-footer {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-top: 8px;
}

.suggestion-score {
	font-size: 12px;
	color: #6b7280;
}

.ai-agentic-cta {
	margin-top: 20px;
}

.ai-cta-box {
	border: 1px dashed #d1d5db;
	border-radius: 8px;
	padding: 14px;
	margin-top: 10px;
	text-align: left;
	background: #fafafa;
}

.ai-cta-title {
	font-weight: 600;
	color: #111827;
	font-size: 13px;
}

.ai-cta-desc {
	font-size: 12px;
	color: #6b7280;
	margin-top: 6px;
}

.ai-chat-wrapper {
	margin-top: 16px;
	display: flex;
	flex-direction: column;
	height: calc(100vh - 380px);
}

.ai-messages {
	flex: 1;
	overflow-y: auto;
	display: flex;
	flex-direction: column;
	gap: 8px;
}

.ai-msg.user {
	align-self: flex-end;
}

.ai-msg.assistant {
	align-self: flex-start;
}

.ai-bubble {
	max-width: 85%;
	padding: 8px 12px;
	border-radius: 10px;
	background: #f3f4f6;
	font-size: 12px;
}

.ai-msg.user .ai-bubble {
	background: #111827;
	color: #fff;
}

.ai-thinking {
	font-size: 12px;
	color: #6b7280;
}

.ai-input-bar {
	margin-top: 8px;
	display: flex;
	gap: 8px;
}

.ai-chat-box {
	background: #fafafa;
	border: 1px solid #e5e7eb;
	border-radius: 8px;
	padding: 10px;
	margin-bottom: 10px;
}

.ai-chat-text {
	font-size: 12px;
}

.ai-chat-actions {
	display: flex;
	gap: 6px;
	margin-top: 8px;
}

.ai-thinking {
	font-size: 12px;
	color: #6b7280;
	margin-top: 10px;
}

.ai-sticky-input {
	position: sticky;
	bottom: 0;
	background: white;
	padding-top: 10px;
}

.template-section {
	height: 90%;
	overflow: auto;
}

.ai-chat-text {
	font-size: 12px;
	line-height: 1.5;
	color: #111827;
}

.ai-chat-text ::v-deep * {
	margin: 4px 0;
	padding: 0;
	box-sizing: border-box;
}

.ai-chat-text ::v-deep p {
	margin-bottom: 6px;
}

.ai-chat-text ::v-deep h1,
.ai-chat-text ::v-deep h2,
.ai-chat-text ::v-deep h3 {
	font-size: 13px;
	font-weight: 600;
	margin-bottom: 6px;
}

.ai-chat-text ::v-deep ul,
.ai-chat-text ::v-deep ol {
	padding-left: 14px;
	margin-bottom: 6px;
}

.ai-chat-text ::v-deep li {
	margin-bottom: 4px;
}

.ai-chat-text ::v-deep hr {
	border: none;
	border-top: 1px solid #e5e7eb;
	margin: 8px 0;
}

.ai-chat-text ::v-deep strong {
	font-weight: 600;
}

.ai-thinking {
	display: flex;
	align-items: center;
	gap: 8px;
	color: #909399;
	font-size: 14px;
}

.dots i {
	width: 6px;
	height: 6px;
	margin: 0 2px;
	background: currentColor;
	border-radius: 50%;
	display: inline-block;
	animation: blink 1.4s infinite both;
}

.dots i:nth-child(2) {
	animation-delay: 0.2s;
}

.dots i:nth-child(3) {
	animation-delay: 0.4s;
}

@keyframes blink {
	0% {
		opacity: .2;
	}

	20% {
		opacity: 1;
	}

	100% {
		opacity: .2;
	}
}
</style>
